import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { TID } from "@/lib/testIds";

const FAQS = [
  {
    key: "was",
    q: "Was genau ist ein Chiptuning-Fileservice?",
    a: "Wir optimieren die Software (das Kennfeld) im Steuergerät deines Fahrzeugs. Du lädst das Originalfile hoch, wir passen es individuell an und liefern dir das optimierte File zurück — für mehr Leistung oder weniger Verbrauch.",
  },
  {
    key: "fahrzeuge",
    q: "Für welche Fahrzeuge bietet ihr Files an?",
    a: "Für PKW, LKW und Agrar-Nutzfahrzeuge wie Traktoren und Erntemaschinen. Über 12.000 Steuergeräte werden unterstützt — Marke und Modell prüfst du am schnellsten im Konfigurator.",
  },
  {
    key: "dauer",
    q: "Wie lange dauert die Bearbeitung?",
    a: "Die meisten Files sind innerhalb weniger Minuten fertig. Bei individuellen Anpassungen kann es etwas länger dauern — du wirst über das Portal informiert.",
  },
  {
    key: "sicher",
    q: "Ist das Tuning sicher für den Motor?",
    a: "Ja. Jedes File wird von unseren Technikern erstellt und innerhalb sicherer Toleranzen abgestimmt. Wir bewegen uns bewusst nicht am mechanischen Limit.",
  },
  {
    key: "start",
    q: "Wie starte ich?",
    a: "Registriere dich im Portal, lade dein File hoch — oder kontaktiere uns direkt per WhatsApp bzw. E-Mail. Wir helfen dir gern weiter.",
  },
];

export default function Faq() {
  return (
    <section id="faq-section" data-testid={TID.faq.root} className="py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <div className="mb-14 text-center">
          <p className="text-sm uppercase tracking-[0.35em] text-primary mb-4">FAQ</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Häufige Fragen
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f) => (
              <AccordionItem key={f.key} value={f.key} data-testid={TID.faq.item(f.key)} className="border-b border-white/10">
                <AccordionTrigger className="font-display uppercase tracking-tight text-lg md:text-xl text-white hover:text-primary text-left py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/55 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
